

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class CompanyView extends BaseEntity
{   
    public Name: string; 
    public Code: string; 
    public FullName: string; 
	
}



